import PlaceModel          from '@/models/services/website/PlaceModel';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class EventModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'id': id;
		'partial': string;
		'existsInContentToPublish': string;
		'paid': string;
		'private': string;
		'hourIsFinal': string;
		'dayIsFinal': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'date[before]': id;
		'date[strictly_before]': id;
		'date[after]': id;
		'date[strictly_after]': id;
		'start[before]': id;
		'start[strictly_before]': id;
		'start[after]': id;
		'start[strictly_after]': id;
		'end[before]': id;
		'end[strictly_before]': id;
		'end[after]': id;
		'end[strictly_after]': id;
		'daisukiCount': id;
		'exists[eventRequiredObjects]': string;
		'exists[place]': string;
		'completionPercent[between]': id;
		'completionPercent[gt]': id;
		'completionPercent[gte]': id;
		'completionPercent[lt]': id;
		'completionPercent[lte]': id;
		'websiteEntertainment': id;
		'eventType': id;
		'eventStatus': string;
		'eventDisplayMode': string;
		'slug': id;
		'place': id;
		'programmingWorkflow': id;
		'communicationWorkflow': id;
		'planificationWorkflow': id;
		'eventParticipations.participation': id;
		'eventPartnerships.partnership': id;
		'eventTaxonomies.taxonomy': id;
		'eventTaxonomies.position': string;
		'eventTags.tag': id;
		'eventUserGroups.userGroup': id;
		'search': string;
	};

	private declare _tsSorts: {
		'id': string;
		'date': string;
		'start': string;
		'end': string;
		'createdAt': string;
		'updatedAt': string;
		'completionPercent': string;
		'translations.title': string;
	};

	static get path(): string {
		return 'events/{?id}';
	}

	@doc.string declare slug: string;
	@doc.date declare date: Dayjs;
	@doc.date declare start: Dayjs;
	@doc.date declare end: Dayjs;
	@doc.number declare completionPercent: number;
	@doc.boolean declare paid: boolean;
	@doc.boolean declare hourIsFinal: boolean;
	@doc.boolean declare dayIsFinal: boolean;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
	@doc.model(PlaceModel) declare place: PlaceModel;

	getTitle(lang: string) {
		return this.getTranslation<string, string>('title', lang, '');
	}

	get startDate() {
		const time = this.get<string, string>('start', '');
		if (!time) return this.date.clone();
		const [hours, minutes, seconds] = time.split(':').map(Number);
		return this.date.clone().hour(hours).minute(minutes).second(seconds);
	}

	get endDate() {
		const time = this.get<string, string>('end', '');
		if (!time) return this.date.clone();
		const [hours, minutes, seconds] = time.split(':').map(Number);
		return this.date.clone().hour(hours).minute(minutes).second(seconds);
	}
}
